import React from "react";
import dayjs from "dayjs";
import { ArrowRight } from "@speedoc/design-assets/build/icons";
import Link from "./link";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default ({ backgroundImage, headLine, date, path, link = null }) => {
  const url = link ?? path;

  return (
    <div id="pressSectionCard">
      <Link
        link={url}
        text={
          <div className="pressSectionCard-background">
            <LazyLoadImage
              className="pressSectionCard-background-image"
              alt="press section card"
              src={backgroundImage}
              effect="blur"
            />
          </div>
        }
      />
      <div className="pressSectionCardInner">
        <p className="date">{dayjs(date).format("DD MMMM, YYYY")}</p>
        <Link link={url} text={<p className="headLine">{headLine}</p>} />
        <Link
          link={url}
          className="buttonLink readMore"
          arrow="right"
          text={
            <>
              <span>Read More</span>
              <ArrowRight className="arrow right" />
            </>
          }
        />
      </div>
    </div>
  );
};
